import React from 'react';
import PropTypes from 'prop-types';
import FormControlLabel from '@mui/material/FormControlLabel';
import MuiCheckbox from '@mui/material/Checkbox';

function Checkbox({ label, color = 'primary', checked, ...rest }) {
  const safeChecked = typeof checked === 'boolean' ? checked : false;

  return (
    <FormControlLabel
      control={<MuiCheckbox color={color} checked={safeChecked} {...rest} />}
      label={label}
    />
  );
}

Checkbox.propTypes = {
  label: PropTypes.string,
  color: PropTypes.string,
  checked: PropTypes.bool
};

export default React.memo(Checkbox);
